import {Authenticated} from './middleware'

export default [

  {
    name: 'visit.index',
    path: '/',
    redirect: {name: 'visit.list'},
    component: () => import ('../../views/cpanel/visit/index'),
    meta: {
      title: 'Сессии',
      back: 'cpanel.dashboard',
      middleware: Authenticated
    },
    children: [
      // {
      //   name: 'visit.lite',
      //   path: 'lite',
      //   component: () => import ('../../views/cpanel/visit/OpenLight.vue'),
      //   meta: {
      //     title: 'Доступные сессии',
      //     back: 'cpanel.dashboard',
      //     middleware: Authenticated
      //   },
      // },
      {
        name: 'visit.list',
        path: 'list',
        component: () => import ('../../views/cpanel/visit/List'),
        meta: {
          title: 'Визиты',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        },
      },
      {
        name: 'visit.item',
        path: ':id?/anketa',
        component: () => import ('../../views/cpanel/visit/Item'),
        meta: {
          title: 'Анкета',
          back: 'visit.list',
          middleware: Authenticated,
          permission: 'can.manage.users'
        }
      },
      {
        name: 'visit.questionnaires',
        path: ':id?/questionnaires',
        component: () => import ('../../views/cpanel/visit/Conclusion'),
        meta: {
          title: 'Questionnaires',
          back: 'visit.list',
          middleware: Authenticated
        }
      },
      {
        name: 'visit.dynamics',
        path: ':id?/dynamics',
        component: () => import ('../../views/cpanel/visit/Dynamics'),
        meta: {
          title: 'Динамика',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        }
      },
      {
        name: 'visit.documents',
        path: ':id?/documents',
        component: () => import ('../../views/cpanel/visit/Documents'),
        meta: {
          title: 'Документы',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        }
      },
      {
        name: 'visit.device',
        path: ':id?/device',
        component: () => import ('../../views/cpanel/visit/Device'),
        meta: {
          title: 'Приборы',
          back: 'visit.list',
          middleware: Authenticated
        }
      },
      {
        name: 'visit.conclusion',
        path: ':id?/conclusion',
        component: () => import ('../../views/cpanel/visit/Conclusion'),
        meta: {
          title: 'Заключение',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        }
      },
      {
        name: 'visit.state',
        path: ':id?/state',
        component: () => import ('../../views/cpanel/visit/State'),
        meta: {
          title: 'Индекс здоровья',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        }
      }
    ]
  },


];
